var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-chat-list"},[(_vm.list.length)?_vm._l((_vm.list),function(item){return _c('new-chat-contact-item',{key:item.id,attrs:{"item":item},on:{"click":function($event){return _vm.$emit('select', $event)}}})}):_c('div',{staticClass:"new-chat-list__empty"},[_vm._v("Нет чатов")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }